export const ordersStatisticTypes = [
  { value: 'amount', label: 'Продажі ₴', description: 'Відображається обʼєм продажів у грн.' },
  { value: 'count', label: 'Продажі ШТ', description: 'Відображається кількість проданих шт.' },
  { value: 'earnings', label: 'Комісійні винагороди', description: 'Відображається заробіток у грн.' },
];
